export default "__VITE_ASSET__95db1872__"